<!-- formulario.component.html -->
<div class="container mt-4">
    <div class="d-flex flex-wrap justify-content-start gap-2">
        <div *ngIf="permisionsService.showDashboard">
            <a [routerLink]="['/dashboard']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi bi-grid-1x2 fs-1 icono"></i>
                    <p class="mb-0">Dashboard</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showPlans">
            <a [routerLink]="['/plans']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi bi-clipboard-check fs-1 icono"></i>
                    <p class="mb-0">Plans</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showCustomers && getCustomersRoute">
            <a [routerLink]="getCustomersRoute"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi bi-people fs-1 icono"></i>
                    <p class="mb-0">Customers</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showDevices">
            <a [routerLink]="['/devices']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
              <div class="card-body">
                <i class="bi bi-phone-landscape fs-1 icono"></i>
                <p class="mb-0">Devices</p>
              </div>
            </a>
        </div>
        <div *ngIf="permisionsService.showDistributors && getDistributorsRoute">
          <a [routerLink]="getDistributorsRoute"
             class="link-green card d-flex flex-column justify-content-center align-items-center">
            <div class="card-body">
              <i class="bi bi-people fs-1 icono"></i>
              <p class="mb-0">Distributors</p>
            </div>
          </a>
        </div>
        <div *ngIf="permisionsService.showPartners">
            <a [routerLink]="['/partners']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi bi-person fs-1 icono"></i>
                    <p class="mb-0">Partners</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showUserManagement">
            <a [routerLink]="['/user-management']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi bi-person-check fs-1 icono"></i>
                    <p class="mb-0">User Management</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showRoleManagement">
            <a [routerLink]="['/role-management']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi bi-person-workspace fs-1 icono"></i>
                    <p class="mb-0">Role Management</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showRoleManagement">
            <a [routerLink]="['/notifications']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi-bell fs-1 icono"></i>
                    <p class="mb-0">Notifications</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showRoleManagement">
            <a [routerLink]="['/inventory']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi-box-seam fs-1 icono"></i>
                    <p class="mb-0">Inventory</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showSendSms && canSendSMS">
            <a [routerLink]="['/sendSms']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi bi-send fs-1 icono"></i>
                    <p class="mb-0">sendSMS</p>
                </div>
            </a>
        </div>

        <div *ngIf="permisionsService.showTickets">
            <a [routerLink]="['/tickets']"
               class="link-green card d-flex flex-column justify-content-center align-items-center">
                <div class="card-body">
                    <i class="bi  bi-ticket-perforated fs-1 icono"></i>
                    <p class="mb-0">Tickets</p>
                </div>
            </a>
        </div>


    </div>
</div>
<div class="container mt-5" *ngIf="statusNotification">
  <div class="accordion accordion-flush" id="accordionExample">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
          style="font-weight: bold; font-size: 1.5rem"
        >
          Announcements
        </button>
      </h2>
      <div
        id="collapseOne"
        class="accordion-collapse collapse show"
        aria-labelledby="headingOne"
        data-bs-parent="#accordionExample"
      >
        <div class="accordion-body">
          <div [innerHTML]="sanitizedHtmlContent"></div>
        </div>
      </div>
    </div>
  </div>
</div>
